import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId) => {
  const nowIso = new Date().toISOString();
  const endpoint = URLS.venue.getDisabledTimeWindows({ venueId, endsAfter: nowIso });

  return httpClient.get(endpoint).then(transformV2ClientResponse);
};

export default makeEntityScaffold('SAGA.API.VENUE_DISABLED_TIME_WINDOWS', handler, {
  defaultKey: (client, venueId) => venueId,
});
